<template>
    <div id="LmTextInputBuilderUi" class="row align-items-center">
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.componentProps.value"
        @input="$emit('input', component)"
        :label="$t('value')"
        :placeholder="$t('value')"
      />
      <LmSelect
        class="col-12 col-md-4"
        v-model="component.componentProps.type"
        :options="{
          content: [{value: 'submit', text: 'Submit'}, {value: 'button', text: 'Button'}]
        }"
        :label="$t('type')"
        @input="$emit('input', component)"
      />
      <LmSelect
        class="col-12 col-md-4"
        v-model="component.actions.click.type"
        :options="actionsOptions"
        :label="$t('action')"
        @input="$emit('input', component)"
      />
      <LmTextInput
        v-if="component.actions.click.type === 'submit'"
        class="col-12 col-md-4"
        v-model="component.actions.click.arguments.path"
        @input="$emit('input', component)"
        :label="$t('post_path')"
        placeholder="/mi-endopind-create"
      />
      <LmTextInput
        v-if="component.actions.click.type === 'submit'"
        class="col-12 col-md-4"
        v-model="component.actions.click.arguments.pathUpdate"
        @input="$emit('input', component)"
        :label="$t('put_path')"
        placeholder="/mi-endopind-update"
      />
      <LmSelect
        v-if="component.actions.click.type === 'delete'"
        class="col-12 col-md-4"
        v-model="component.actions.click.arguments.deleteMethod"
        :options="deleteTypeOptions"
        :label="$t('delete_type')"
        @input="$emit('input', component)"
      />
      <LmTextInput
        v-if="component.actions.click.type === 'delete'"
        class="col-12 col-md-4"
        v-model="component.actions.click.arguments.pathDelete"
        @input="$emit('input', component)"
        :label="$t('delete_path')"
        placeholder="/mi-endopind-remove"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.class"
        @input="$emit('input', component)"
        :label="$t('comp_columns')"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.componentProps.icon"
        @input="$emit('input', component)"
        :label="$t('comp_icon')"
        placeholder="Fontawesome icon"
      />
      <LmSelect
        class="col-12 col-md-4"
        v-model="component.componentProps.iconPosition"
        :options="{
          content: [
          {text: $t('left'), value: 'left'},
          {text: $t('right'), value: 'right'}
          ]
        }"
        :label="$t('comp_icon_position')"
        @input="$emit('input', component)"
      />
      <LmTextInput
        class="col-12 col-md-4"
        v-model="component.componentProps.buttonClass"
        @input="$emit('input', component)"
        :label="$t('comp_styles')"
      />
      <LmSelect
        class="col-12 col-md-4"
        v-model="component.componentProps.size"
        :options="{
          content: [
          {text: $t('small'), value: 'sm'},
          {text: $t('medium'), value: 'md'},
          {text: $t('large'), value: 'lg'},
          ]
        }"
        :label="$t('size')"
        @input="$emit('input', component)"
      />
      <LmCheckbox
        class="col-12 col-md-4"
        v-model="component.componentProps.requireConfirmation"
        :labelSingle="$t('require_confirmation')"
        @input="$emit('input', component)"
      />
      <LmTextInput
        v-if="component.componentProps.requireConfirmation"
        class="col-12 col-md-6"
        v-model="component.componentProps.confirmationTitle"
        @input="$emit('input', component)"
        :label="$t('confirmation_title_setter')"
      />
      <LmTextInput
        v-if="component.componentProps.requireConfirmation"
        class="col-12 col-md-6"
        v-model="component.componentProps.confirmationMessage"
        @input="$emit('input', component)"
        :label="$t('confirmation_message_setter')"
      />
      <div class="col-12" v-if="component.actions.click.type === 'delete' && component.actions.click.arguments.deleteMethod === 'put'">
        <h5>{{ $t('prop_to_manage_logic_delete') }}</h5>
        <div class="row">
          <LmTextInput
            class="col-12 col-md-5"
            v-model="component.actions.click.arguments.logicDeleteProperty"
            :label="$t('property')"
            :placeholder="$t('property')"
            @input="$emit('input', component)"
          />
          <LmSelect
            class="col-12 col-md-4"
            v-model="component.actions.click.arguments.logicDeleteValue"
            :options="{
              content: [
              {text: 'false', value: false},
              {text: 'true', value: true}
              ]
            }"
            :label="$t('value')"
            @input="$emit('input', component)"
          />
        </div>
      </div>
      <div class="col-12">
        <h5>{{ $t('custom_params') }}</h5>
        <div
          v-for="(param, index) in params"
          :key="index"
          class="row align-items-center"
        >
          <LmTextInput
            :id="`property-${index}`"
            class="col-12 col-md-5"
            v-model="params[index].property"
            @input="onParamsChange"
            :label="$t('property')"
            :placeholder="$t('property')"
          />
          <LmTextInput
            :id="`value-${index}`"
            class="col-12 col-md-5"
            v-model="params[index].value"
            @input="onParamsChange"
            :label="$t('value')"
            :placeholder="$t('value')"
          />
          <font-awesome-icon
            :id="`trash-icon-${index}`"
            class="clickable mt-3 col-12 col-md-1"
            icon="trash"
            @click="removeParam(index)"
          />
        </div>
        <LmButton
          :id="`lm-button`"
          type="button"
          :value="$t('add_param')"
          @click.native="addParam"
        />
      </div>
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        :self="component.formObjectToSendToServerProperty"
      />
      <LmConditionalByEditModeBuilderUi
        :component="component"
        @input="$emit('input', component)"
        />
    </div>
</template>

<script>
import LmTextInput from '@/components/form/elements/LmTextInput'
import LmSelect from '@/components/form/elements/LmSelect'
import LmCheckbox from '@/components/form/elements/LmCheckbox'
import LmButton from '@/components/form/elements/LmButton'
import LmConditionalBuilderUi from '@/components/lmFormBuilderUi/LmConditionalBuilderUi'
import LmConditionalByEditModeBuilderUi from '@/components/lmFormBuilderUi/LmConditionalByEditModeBuilderUi'

export default {
  data () {
    return {
      component: {},
      params: [],
      actionsOptions: {
        content: [{
          value: 'submit',
          text: this.$t('save_or_update')
        }, {
          value: 'delete',
          text: this.$t('delete')
        }, {
          value: 'cancel',
          text: this.$t('cancel')
        }]
      },
      deleteTypeOptions: {
        content: [{
          value: 'put',
          text: this.$t('logic')
        }, {
          value: 'delete',
          text: this.$t('permanent')
        }]
      }
    }
  },
  components: {
    LmTextInput,
    LmSelect,
    LmCheckbox,
    LmButton,
    LmConditionalBuilderUi,
    LmConditionalByEditModeBuilderUi
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    },
    visibilityDependOnConditions: {
      type: Object,
      default: () => ({
        isActive: false,
        conditions: []
      })
    },
    leftValueToCompareOptions: {
      type: Object,
      default: () => ({
        disabledOption: '',
        content: []
      })
    },
    componentData: {
      type: Object,
      default: () => (
        {
          class: 'col-auto',
          componentName: 'LmButton',
          componentProps: {
            isVisible: true,
            type: 'submit',
            value: 'Submit',
            buttonClass: 'btn-primary'
          },
          actions: {
            click: {
              type: 'submit',
              arguments: {
                path: ''
              }
            }
          }
        }
      )
    }
  },
  methods: {
    addParam () {
      this.params.push({
        property: '',
        value: ''
      })
    },
    removeParam (index) {
      this.params.splice(index, 1)
      this.onParamsChange()
    },
    onParamsChange () {
      // Paso los parámetros personalizables a un objeto antes de emitirlo al componente padre
      // Nota: forma ideal para modificar reactivamente propiedades de un objeto
      const paramsObject = {}
      for (const param of this.params) {
        const value = isNaN(param.value) || param.value === '' ? param.value : Number(param.value)
        paramsObject[param.property] = value
      }
      this.component.actions.click.params = paramsObject
      this.$emit('input', this.component)
    }
  },
  created () {
    this.component = this.componentData

    // Paso los parámetros personalizables a un array para el componente
    if (this.component?.actions?.click?.params) {
      for (const param in this.component.actions.click.params) {
        this.params.push({
          property: param,
          value: this.component.actions.click.params[param]
        })
      }
    }
  }
}
</script>
